<template>
  <div>
    <div class="hidden-md-and-down">
      <el-table
        :data="emails"
        stripe
        :cell-style="{padding:'2px'}"
        v-loading="emailsLoading">
        <div slot="empty">
          <span>Aucune communication courriel</span>
        </div>
        <el-table-column :label="$t('common.date')" sortable prop="delivered_at" width="100">
          <template slot-scope="scope">
            <span style="word-break:break-word">{{_moment(scope.row.delivered_date || scope.row.delivered_at,'l')}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('communications.communication')" sortable prop="template.name" width="200" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span style="word-break:break-word"><el-link type="primary" @click="openEmailPreview(scope.row.id)">{{$t('emails.'+scope.row.template.name)}}</el-link></span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('communications.object')" sortable prop="template.name" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span style="word-break:break-word">{{scope.row.subject}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('communications.recipient')" sortable prop="email_to">
          <template slot-scope="scope">
            <!-- <el-popover
              placement="top-start"
              title="Contact"
              width="200"
              trigger="hover">
              <div v-html="getInfoContact(scope.row.user_id)"></div>
              <span slot="reference" style="word-break:break-word">{{scope.row.email_to}}</span>
            </el-popover> -->
            <span slot="reference" style="word-break:break-word">{{scope.row.email_to}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('common.status')" sortable prop="status.code" width="150">
          <template slot-scope="scope">
            <el-tag :type="getTagType(scope.row.status)" style="margin-left:10px;">{{$t('emails.statuses.'+scope.row.status.code)}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column :label="$t('common.readAt')" sortable prop="read_date" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.opened_at!=null" style="word-break:break-word">{{_moment(scope.row.opened_at,'l')}}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="hidden-lg-and-up">
      <h5>{{$t('communications.communications')}}</h5>
      <el-divider/>
      <div v-for="email in emails" :key="email.id">
        <EmailCommunicationTile :sendDate="email.processed_date" :subject="email.subject" :recipient="email.email_to" :status="email.status" :readDate="email.read_date"></EmailCommunicationTile>
      </div>
      <div v-if="emails.length==0" style="text-align:center">
          <span  class="secondary-text fs-14">{{$t('communications.noCommunications')}}n</span>
      </div>
    </div>
    <EmailDeliveryPreview :visible="emailDeliveryPreviewVisible" :emailDeliveryId="emailDeliveryId" @close="closeEmailPreview"></EmailDeliveryPreview>
  </div>
</template>
<script>
import moment from 'moment-timezone'
import axios from 'axios'
import EmailCommunicationTile from '@/components/emails/email-communication-tile'
import EmailDeliveryPreview from '@/components/emails/email-delivery-preview.vue'

export default {
  name: 'emails-communication-table',
	props: {
    customer : Object,
    contactId : Number,

	},
  data() {
    return {
      emails : [],
      emailsLoading : true,
      emailDeliveryPreviewVisible : false,
      emailDeliveryId:null,
    };
  },components: {
    EmailDeliveryPreview,
    EmailCommunicationTile
  },
	methods: {
    getTagType(status){
      if(status.code=="PENDING"){
        return "info"
      }else if(status.code=="DELIVERED"){
        return "success";
      }else if(status.code=="FAILED"){
        return "warning";
      }else if(status.code=="PERMANENT_FAILED"){
        return "error";
      }
    },
    openEmailPreview(deliveryId){
      this.emailDeliveryId=deliveryId;
      this.emailDeliveryPreviewVisible=true;
    },
    closeEmailPreview(){
      this.emailDeliveryId=null;
      this.emailDeliveryPreviewVisible=false;
    },
    fetchEmails(){
      // console.log(process.env);
      let params = {};
      this.emailsLoading = true;
      if(this.customer!=null || this.contactId!=null){
        params.customerId=this.customer!=null?this.customer.id:undefined;
        params.userId=this.contactId!=null?this.contactId:undefined;
        params.orderBy='processed_date';
        params.direction='DESC';
        return axios.get(process.env.VUE_APP_MAILER_HOSTNAME+":"+process.env.VUE_APP_MAILER_PORT+process.env.VUE_APP_MAILER_PATH+"/emails", {params})
          .then(results=>{
            this.emails = results.data;
            this.emailsLoading=false;
            return results.data;
          })
      }else{
        this.emailsLoading=false;
      }

    },
    getInfoContact(user_id){
      let contact = null;
      if(this.customer.company!=null){
        contact = _.find(this.customer.company.contacts, c=>{
          return c.id==user_id;
        })
      }else{
        contact = _.find(this.customer.contacts, c=>{
          return c.id==user_id;
        })
      }
      if(contact!=null){
        let str = "";
        let email = contact.work_email==null?contact.email:contact.work_email;
        let phone = contact.work_phone==null?contact.phone:contact.work_phone;
        if(contact.first_name!=null && contact.first_name!==''){
          str+=contact.first_name
        }
        if(contact.last_name!=null && contact.last_name!==''){
          str+=" "+contact.last_name;
        }
        return str+"<br>" + email + "<br>" + phone;
      }else{
        return "Information non disponible"
      }
    },
    _moment(datetime, format='LL'){
      return moment(datetime).format(format);
    }

	},
	computed: {


	},
	watch : {
    customer : function(newVal, oldVal){
      if(newVal!=oldVal){
        this.fetchEmails()
      }
    },
    contactId : function(newVal, oldVal){
      if(newVal!=oldVal){
        this.fetchEmails()
      }
    }
	},
  mounted(){
    this.fetchEmails()
  }
}
</script>
<style lang="scss" scoped>




</style>
